// extracted by mini-css-extract-plugin
module.exports = {"imgPreview":"mermaidChart_imgPreview__3qjPV"};